// crm namespace — Book session modal.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "book.chooseService": "Choisissez un service",
    "book.day": "Jour",
    "book.done": "Séance réservée — le client reçoit l'e-mail de confirmation",
    "book.mode": "Mode",
    "book.noSlots": "Aucun créneau libre dans les 60 prochains jours.",
    "book.service": "Service",
    "book.submit": "Réserver",
    "book.time": "Heure de début",
    "book.title": "Réserver une séance",
  },
  en: {
    "book.chooseService": "Choose a service",
    "book.day": "Day",
    "book.done": "Session booked — the client gets the confirmation email",
    "book.mode": "Mode",
    "book.noSlots": "No free time in the next 60 days.",
    "book.service": "Service",
    "book.submit": "Book",
    "book.time": "Start time",
    "book.title": "Book a session",
  },
  es: {
    "book.chooseService": "Elige un servicio",
    "book.day": "Día",
    "book.done": "Sesión reservada: el cliente recibe el correo de confirmación",
    "book.mode": "Modalidad",
    "book.noSlots": "No hay horas libres en los próximos 60 días.",
    "book.service": "Servicio",
    "book.submit": "Reservar",
    "book.time": "Hora de inicio",
    "book.title": "Reservar una sesión",
  },
};
